module.exports = __webpack_public_path__ + "img/main.bd77da89.svg";